<template>
  <div>
    <Card>
      <a-form layout="inline">
        <a-form-item style="margin-bottom: 20px">
          <a-input v-model="dataForm.username" placeholder="账号名"> </a-input>
        </a-form-item>
        <a-form-item>
          <a-button @click="getDataList" type="primary"> 搜索 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button
            @click="addOrUpdateHandle()"
            v-permission="['sys:users:add']"
          >
            新增
          </a-button>
        </a-form-item>
      </a-form>
      <a-table
        :columns="columns"
        :data-source="dataList"
        :pagination="false"
        :loading="dataListLoading"
      >
        <span slot="action" slot-scope="text, record">
          <a-space>
            <a-button
              size="small"
              type="link"
              @click="addOrUpdateHandle(record.id, record.project_id)"
              v-permission="['sys:users:edit']"
              >编辑
            </a-button>
            <a-button
              size="small"
              type="link"
              @click="deleteHandle(record.id)"
              v-permission="['sys:users:delete']"
              >删除</a-button
            >
          </a-space>
        </span>
        <span slot="role_name" slot-scope="text">
          <a-tag color="green" v-if="text">
            {{ text }}
          </a-tag>
          <a-tag color="red" v-else> 未分配角色 </a-tag>
        </span>
      </a-table>
      <a-pagination
        style="margin-top: 20px; float: right"
        show-size-changer
        :current="page"
        show-quick-jumper
        :total="total"
        @showSizeChange="showSizeChange"
        @change="pageCurrentChangeHandle"
        :show-total="(total) => `共 ${total} 条`"
      />
    </Card>
    <addOrUpdate ref="addOrUpdate" @ok="getDataList"></addOrUpdate>
  </div>
</template>

<script>
import addOrUpdate from "./components/usersaddorupdate.vue";
import viewModule from "@/mixins/view-module";
export default {
  components: { addOrUpdate },
  mixins: [viewModule],
  data() {
    return {
      columns: [
        {
          title: "账号名",
          align: "center",
          dataIndex: "username",
          key: "username",
        },
        {
          title: "联系电话",
          align: "center",
          dataIndex: "phone",
          key: "phone",
        },
        {
          title: "邮箱",
          align: "center",
          dataIndex: "mail",
          key: "mail",
        },
        {
          title: "真实姓名",
          align: "center",
          dataIndex: "nickname",
          key: "nickname",
        },
        // {
        //   title: "所属项目",
        //   align: "center",
        //   dataIndex: "project_name",
        //   key: "project_name",
        //   filterDropdownVisible: false,
        // },
        {
          title: "角色",
          align: "center",
          dataIndex: "role_name",
          key: "role_name",
          scopedSlots: { customRender: "role_name" },
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      mixinViewModuleOptions: {
        getDataListURL: "/user/page",
        deleteURL: "/user/delete",
      },
      dataForm: { username: "" },
    };
  },
  methods: {
    // 新增 / 修改
    addOrUpdateHandle(id = "", project_id) {
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, project_id);
      });
    },
  },
};
</script>

<style></style>